export default class ProtocolService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('protocols/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('protocols', params)
	}

	createEntity(params){
		return this.apiService.callPost('protocols', params);
	}

	updateEntity(id, params) {
		return this.apiService.callPut('protocols/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('protocols/' + id, params)
	}

	getSimpleEntities(params) {
		return this.apiService.callGet('protocols/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ProtocolService.js